module.exports = __webpack_public_path__ + "static/media/project-thumbnail05.0abe216b.jpg";